import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { httpJSON } from '../../../shared/api/http';

const WATCHLIST_QUERY_KEY = ['watchlists'];

export function useWatchlistsQuery(options = {}) {
  return useQuery({
    queryKey: WATCHLIST_QUERY_KEY,
    queryFn: () => httpJSON('/v1/watchlists'),
    staleTime: 30_000,
    ...options,
  });
}

async function jsonRequest(path, method, body) {
  const res = await fetch(path, {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const message = await res.text();
    throw new Error(message || res.statusText);
  }
  if (res.status === 204) {
    return null;
  }
  return res.json();
}

export function useCreateWatchlistMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => jsonRequest('/v1/watchlists', 'POST', payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: WATCHLIST_QUERY_KEY });
    },
  });
}

export function useUpdateWatchlistMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...payload }) => jsonRequest(`/v1/watchlists/${id}`, 'PUT', payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: WATCHLIST_QUERY_KEY });
    },
  });
}

export function useDeleteWatchlistMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => jsonRequest(`/v1/watchlists/${id}`, 'DELETE'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: WATCHLIST_QUERY_KEY });
    },
  });
}
